export const PRIVACY_POLICY_URL =
  'https://www.spottedzebra.co.uk/privacy/privacy';
